<template>
  <div class="go-to-next-section position-relative">
    <a :class="`half-circle bg-${color} d-flex justify-content-center align-items-center text-decoration-none`" :href="path" :title="$t('action.go_to_next_section')" :style="`box-shadow: inset ${color === 'dark' ? '2px 0px 2px 2px rgba(255, 255, 255, 0.4);' : '2px 2px 0px 0px rgba(38, 38, 38, 0.4)'};`" @click="anchorSoftAnimation">
      <i class="fas fa-angle-down"></i>
    </a>
  </div>
</template>

<script>
import animationsMixin from '@/mixins/animations'

export default {
  mixins: [ animationsMixin ],
  name: 'NextButton',
  props: {
    path: { type: String, required: true },
    color: { type: String, default: 'light' }
  }
}
</script>

<style>
.go-to-next-section {
  width: 100px;
  height: 100px;
  bottom: 50px;
  left: calc(50% - 50px);
}

.go-to-next-section .fas {
  font-size: 30px;
}

.go-to-next-section > .half-circle {
  height: 50%;
  width: 100%;
  border-top-left-radius: 100px;
  border-top-right-radius: 100px;
}

.go-to-next-section > .half-circle:hover .fas {
  animation-name: movingArrow;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
}

@keyframes movingArrow {
  0% {
    transform: rotate(-45deg);
  }

  15% {
    transform: rotate(45deg);
  }

  30% {
    transform: rotate(0);
  }

  100% {
    transform: translateY(10px);
  }
}
</style>
